<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="!OnlyValue">
    <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
            {{data?.name}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-mdc-card-content text-center">
        <span>({{data?.width}} {{'m'|translate}})</span> *
        <span>({{data?.height}} {{'m'|translate}})</span> *
        <span>({{data?.price}} {{'EGP'|translate}})</span> =
        {{ClacAdditions(data?.width,data?.height,data?.price)}}
        {{'EGP'|translate}}
    </mat-card-content>
</mat-card>

<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="OnlyValue">
    <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
            {{data?.name}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-mdc-card-content text-center">
        <span>{{data?.value}} {{'EGP'|translate}}</span>
    </mat-card-content>
</mat-card>